import { Component, OnInit } from '@angular/core'
import { MetaService } from 'src/app/shared/services/meta.service'

import { Aggregation } from '../../shared/interfaces/visualizations/aggregation.interface'
import { VisualizationService } from '../../shared/services/visualization.service'
import { ContentService } from '../../shared/services/content.service'
import {
  DynamicContent,
  DynamicContentItem
} from '../../shared/interfaces/dynamic-content.interface'
import { IncentiveFamilyView } from '../../shared/enums/incentive-family-view.enum'
import { AggregationDataset } from '../../shared/interfaces/visualizations/aggregation-dataset.interface'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  loadingAggregations: boolean = false
  aggregations: Aggregation[]
  otherAggregation: Aggregation

  additionalResources: DynamicContentItem[]

  currentView = IncentiveFamilyView.COMBINED;
  readonly IncentiveView = IncentiveFamilyView;
  governmentTaxSupportCombined:Aggregation;

  constructor(
    private visualizationService: VisualizationService,
    private contentService: ContentService,
    private metaService: MetaService
  ) {}


  ngOnInit(): void {
    this.loadVisualizations();
    this.loadContent();
    this.metaService.setTags('home');
  }

  private loadVisualizations(): void {

    this.loadingAggregations = true;

    this.visualizationService.listMainVisualizations().then(
      (visualizationRes: {
        aggregations: Aggregation[]
        otherAggregation: Aggregation
      }) => {
        this.loadingAggregations = false
        this.aggregations = visualizationRes.aggregations
        this.otherAggregation = visualizationRes.otherAggregation
        this.governmentTaxSupportCombined = this.aggregations.find(
          a => a.id === 'governmentTaxSupportCombined'
        );
        this.governmentTaxSupportCombined.datasets = this.mapGovernmentTaxSupport(this.governmentTaxSupportCombined);
      },
      (err) => {
        this.loadingAggregations = false
      }
    )
  }

  private loadContent(): void {
    this.contentService
      .getDynamicContent()
      .then((dynamicContent: DynamicContent) => {
        this.additionalResources = dynamicContent.homePageContent
      })
  }

  mapGovernmentTaxSupport(data: Aggregation): AggregationDataset[] {
    return data.datasets.map(dataset => ({
      id: data.id,
      csv: dataset.csv,
      label: data.label,
      yAxisLabel: data.unit,

      data: dataset.data.map(row => ({
        label: row.iso,

        subItems: [
          {
            label: 'Direct government funding of business R&D',
            count: row.direct_government_funding_of_business_rd
          },
          {
            label: 'Tax support for R&D expenditure',
            count: row.tax_support_for_rd_expenditure
          },
          {
            label: 'Tax support for R&D and innovation income',
            count: row.tax_support_for_rd_and_innovation_income
          }
        ]
      }))
    }));
  }
}
